import { render, staticRenderFns } from "./ConfirmPermanentDeleteDialog.vue?vue&type=template&id=4e9379cc"
import script from "./ConfirmPermanentDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmPermanentDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports